/* eslint-disable */
// const dotenv = require("dotenv");
// dotenv.config();

const ACCESS_KEY_ID = process.env.accessKeyId;
const SECRET_ACCESS_KEY = process.env.secretAccessKey;

const aws = {
  Auth: {
    identityPoolId: "eu-west-1:1645b6dc-ffeb-4d1d-bc75-2777ef9d7bff",
    region: "eu-west-1",
    userPoolId: "eu-west-1_ax0nA015t",
    userPoolWebClientId: "41jslu2m92e3e8jr80gu1c1lpm",
  },
  IdentityPool: {
    provider: "cognito-idp.eu-west-1.amazonaws.com/eu-west-1_ax0nA015t",
  },
  S3: {
    accessKeyId: ACCESS_KEY_ID,
    secretAccessKey: SECRET_ACCESS_KEY,
    region: "eu-west-1",
  },
};

export default aws;
